import { lazy, type ComponentType } from "react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";

export const lazyRoute = <T extends { default: ComponentType<any> }>(
  importer: () => Promise<T>,
) => lazy(() => lazyWithRetry(importer));